import { useUserDataStore } from "~/stores";

export default function () {
  const registerUser = async () => true

  const loginUser = async (email, password) => {
    try {
      const userDataStore = useUserDataStore();
      const clerk = window.Clerk

      if (!clerk?.loaded) {
        return "A autenticação ainda está carregando. Tente novamente em instantes."
      }

      const result = await clerk.client.signIn.create({
        identifier: email,
        password,
      })

      if (result.status === "complete") {
        await clerk.setActive({ session: result.createdSessionId })
        const token = await clerk.session?.getToken()
        userDataStore.setUser({
          id: result.createdUserId,
          email,
        });
      userDataStore.setToken(token);
      const tokend = useCookie('token')
      tokend.value = token
        return { user: userDataStore.user }
      }

      return "Não foi possível finalizar o login."
    } catch (error) {
      const code = await traduzirErroSignInClerk(error)

      return code
    }

  }
  const getCurrentUser = async () => {
    return (typeof window !== 'undefined' ? window.Clerk?.user : null) || null
  };

  const logoutUser = async () => {
    const userDataStore = useUserDataStore();
    const tokend = useCookie('token')

    // Always clear local auth state first to avoid redirect loops.
    tokend.value = null
    userDataStore.setUser(null)
    userDataStore.setToken(null)

    try {
      if (typeof window !== 'undefined' && window.Clerk?.loaded) {
        await window.Clerk.signOut()
      }
      return true
    } catch (e) {
      console.log(e)
      return true
    }

  }

  async function traduzirErroSignInClerk(error) {
    let mensagemErro;
    const errorCode = error?.errors?.[0]?.code || error?.code

    switch (errorCode) {
      case 'form_identifier_not_found':
        mensagemErro = 'E-mail ou Senha incorreta.';
        break;
      case 'form_param_format_invalid':
        mensagemErro = 'E-mail inválido.';
        break;
      case 'form_password_incorrect':
        mensagemErro = 'E-mail ou Senha incorreta.';
        break;
      case 'too_many_requests':
        mensagemErro = 'Muitas tentativas de login. Tente novamente mais tarde.';
        break;
      case 'network_error':
        mensagemErro = 'Erro de conexão. Verifique sua conexão com a internet.';
        break;
      default:
        mensagemErro = 'Ocorreu um erro ao tentar fazer login. Por favor, tente novamente.';
        break;
    }

    return mensagemErro;
  }
  return {
    registerUser,
    loginUser,
    getCurrentUser,
    logoutUser
  }
}
